require('./bootstrap');

//require('../../public/plugins/jquery/jquery-3.5.1.min.js');
require('../../public/plugins/sweetalert/js/sweetalert.min.js');

require('../../public/app/js/api.js');
require('../../public/app/js/cache.js');
require('../../public/app/js/common.js');
require('../../public/app/js/stripe.js');
